import DomainListModel from './DomainListModel';
import DomainModel from './DomainModel';
import UsersModel from './UsersModel';
import IntegrationsModel from './IntegrationsModel';
import ReportsModel from './ReportsModel';
import PasswordModel from './PasswordModel';
import UserModel from './UserModel';
import LinkolnDomainsModel from './LinkolnDomains';
import ShortLinkolnsModel from './ShortLinkolnsModel';
import LinkolnEmailModel from './LinkolnEmailsModel';
import CartModel from './CartModel';
import {logIn, signUp, demoSignUp, verify} from '../services/LogIn';
import {sendContactForm} from '../services/ContactForm';
import { action, actionOn, thunk } from 'easy-peasy';


const AppModel = {
  is_logged_in: false,

  current_domain: DomainModel,
  domains: DomainListModel,
  linkoln_domains: LinkolnDomainsModel,
  short_linkolns: ShortLinkolnsModel,
  linkoln_emails: LinkolnEmailModel,
  integrations: IntegrationsModel,
  password: PasswordModel,
  reports: ReportsModel,
  users: UsersModel,
  user: UserModel,
  cart: CartModel,

  onGetDomains: actionOn(
    actions => actions.domains.getDomains,
    (state, target) => {
      if ((!state.current_domain || !state.current_domain.domain) && state.domains.good_domains.length) {
        state.current_domain = state.domains.good_domains[0];
      }
    }
  ),
  setIsLoggedIn: action((state, is_logged_in) => {
    if (state.is_logged_in !== is_logged_in) {
      state.is_logged_in = is_logged_in;
    }
  }),
  setInitialDomain: action((state, domain) => {
    if (!state.current_domain || !state.current_domain.domain) {
      state.current_domain = domain;
    }
  }),
  setCurrentDomain: action((state, domain) => {
    if (!state.current_domain || (state.current_domain.domain !== domain.domain)) {
      state.current_domain = domain;
    }
  }),
  logIn: thunk(async (actions, payload) => {
    const response = await logIn(payload.username, payload.password);
    if (response.success) {
      actions.setIsLoggedIn(true);
    }
    return response;
  }),
  signUp: thunk(async (actions, payload) => {
    console.log(payload);
    const response = await signUp(payload.email, payload.first_name, payload.last_name, payload.signup_code, payload.domain, payload.subdomain);
    return response;
  }),
  demoSignUp: thunk(async (actions, payload) => {
    const response = await demoSignUp(payload.email);
    return response;
  }),
  verifyAccount: thunk(async (actions, payload) => {
    const response = await verify(payload.code, payload.password);
    return response;
  }),
  submitContactForm: thunk(async (actions, payload) => {
    const response = await sendContactForm(payload);
    return response;
  }),
}

export default AppModel;

